export default defineNuxtPlugin(() => {
  const store = useMainStore();

  try {
    store.initVolumeFromCookieOrLocaleStorage();
  } catch (e) {
    console.warn('[VolumePlugin] Failed to initialize volume:', e);
  }

  watch(
    () => store.volume,
    () => {
      try {
        store.saveVolumeToCookieAndLocaleStorage();
      } catch (e) {
        console.warn('[VolumePlugin] Failed to save volume:', e);
      }
    },
    { deep: true }
  );
});
